"use client";

import { useGeo } from "../context/GeoContext";


export function useCallCheck() {
   const { agency, hasSelected } = useGeo();

  //console.log("Agence sélectionnée :", agency);
 // console.log("Agence sélectionnée ?", hasSelected);

 
  const isAllowed =
    hasSelected === true &&
    agency !== null &&
    agency.showIdelioButton === true;

  return { isAllowed, agency };
}
